<template>
	<div @click="goToUserInquiryDetail(item)">
		<DetailCard>
			<template v-slot:title>
				<div class="column col-auto">{{ inquiryDate }}</div>
				<div class="column col-auto col-ml-auto">{{ item.ar_type }}</div>
			</template>
			<template v-slot:content>
				<div class="inquiry-card-content">
					<h2 class="inquiry-card-content__title">{{ item.ar_title }}</h2>
					<div class="inquiry-card-content__detail">
						<span>{{ shopName }}</span>
						<span class="u-color-red">{{ resultReply }}</span>
					</div>
				</div>
			</template>
		</DetailCard>
	</div>
</template>

<script>
import { formatDateString } from '@/utils/util';
import DetailCard from '@/components/common/DetailCard';

export default {
	components: {
		DetailCard,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
	},
	computed: {
		shopName() {
			return this.item.ar_shop2 ? this.item.ar_shop2 : '지점 선택안함';
		},
		resultReply() {
			return Number(this.item.ar_reply) > 0 ? '답변완료' : '접수중';
		},
		inquiryDate() {
			const dateStr = this.item.datetime.split(' ')[0];
			return formatDateString(dateStr);
		},
	},
	methods: {
		goToUserInquiryDetail(item) {
			this.$router.push({ name: 'inquiryDetail', params: { id: item.ar_id } });
		},
	},
};
</script>

<style scoped>
.inquiry-card-content__title {
	margin-bottom: 1rem;
	font-size: 0.875rem;
	font-weight: 500;
}

.inquiry-card-content__detail {
	color: #666;
	font-size: 0.8125rem;
	font-weight: 300;
	text-align: right;
}

.inquiry-card-content__detail > span::before {
	content: '';
	display: inline-block;
	width: 1px;
	height: 10px;
	margin: 0 0.5rem;
	background: #c8c8c8;
}

.inquiry-card-content__detail > span:first-child::before {
	display: none;
}
</style>
